import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})
export class CurrencyComponent implements OnInit {

  model = {
    'table_name': 'currency', 'currency_id': '0', 'currency_name': '', 'currency_name_en': '', 'currency_code': '', 'is_base': 0,
    'multiply': '1', 'comment': ''
  };

  Success_Msg; Error_Msg; Currency_Name_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<CurrencyComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Currency_Name_Msg').subscribe((res: string) => {
      this.Currency_Name_Msg = res;
    });

  }


  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
    this.multiply();
  }

  multiply() {
    let multiply = document.getElementById('multiply') as HTMLInputElement;
    if (this.model['is_base']) {
      multiply.readOnly = true;
      this.model['multiply'] = '1';
      this.model['is_base'] = 1;

    }
    else {
      multiply.readOnly = false;
      this.model['is_base'] = 0;
    }
  }

  add() {
    if (this.model['currency_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['currency_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'currency_id': this.model['currency_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['currency_name'] == '') {
      alert(this.Error_Msg);
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
